import { createStore } from 'vuex';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const store = createStore({
  state: {
    // Your state properties
  },
  mutations,
  actions,
  getters,
});

export default store;
